<template>
  <div>
    <div>
      <v-btn text color="primary accent-4" @click="linkToHome">На главную</v-btn>
    </div>
    <div>
      <!-- Авторизация -->
      <wapi-panel :title="'Авторизация'">
        <template v-slot:content>
          <v-expansion-panels>
            <wapi-api-panel :title="'Auth'" :httpType="'POST'" :path="'connect/token'">
              <template v-slot:description>
                <auth />
              </template>
            </wapi-api-panel>
          </v-expansion-panels>
        </template>
      </wapi-panel>
      <!-- Радары -->
      <wapi-panel :title="'Радары'">
        <template v-slot:content>
          <v-expansion-panels>
            <wapi-api-panel
              :title="'RadarValidTimesGeoJson'"
              :httpType="'GET'"
              :path="'/api/{api-version}/radar/{territory}/{parameter}/{validtimes}'"
            >
              <template v-slot:description>
                <radar-valid-times-geo-json />
              </template>
            </wapi-api-panel>
            <wapi-api-panel
              :title="'RadarLastTime'"
              :httpType="'GET'"
              :path="'/api/{api-version}/radar/validtime/{territory}/{parameter}/last'"
            >
              <template v-slot:description>
                <radar-last-time />
              </template>
            </wapi-api-panel>
            <wapi-api-panel
              :title="'RadarValidTimes'"
              :httpType="'GET'"
              :path="'/api/{api-version}/radar/validtime/{territory}/{parameter}'"
            >
              <template v-slot:description>
                <radar-valid-times />
              </template>
            </wapi-api-panel>
            <wapi-api-panel
              :title="'RadarTerritories'"
              :httpType="'GET'"
              :path="'/api/{api-version}/radar/territories'"
            >
              <template v-slot:description>
                <radar-territories />
              </template>
            </wapi-api-panel>
          </v-expansion-panels>
        </template>
      </wapi-panel>
      <!-- Прогнозы -->
      <wapi-panel :title="'Прогнозы'">
        <template v-slot:content>
          <v-expansion-panels>
            <wapi-api-panel
              :title="'ForecastPreset'"
              :httpType="'GET'"
              :path="'/api/{api-version}/forecast/preset/{presetId}'"
            >
              <template v-slot:description>
                <forecast-preset />
              </template>
            </wapi-api-panel>
            <wapi-api-panel
              :title="'ForecastByPoint'"
              :httpType="'GET'"
              :path="'/api/{api-version}/forecast/point?latitude={lat}&longitude={lon}'"
            >
              <template v-slot:description>
                <forecast-by-point />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'Forecast'"
              :httpType="'GET'"
              :path="'/api/{api-version}/forecast/preset/{presetId}'"
            >
              <template v-slot:description>
                <forecast />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'LastTime'"
              :httpType="'GET'"
              :path="'/api/{api-version}/forecast/time'"
            >
              <template v-slot:description>
                <forecast-last-time />
              </template>
            </wapi-api-panel>
            <wapi-api-panel
              :title="'ForecastPresets'"
              :httpType="'POST'"
              :path="'/api/{api-version}/forecast/presets'"
            >
              <template v-slot:description>
                <forecast-presets />
              </template>
            </wapi-api-panel>
          </v-expansion-panels>
        </template>
      </wapi-panel>

      <!-- Долгосрочные прогнозы -->
      <wapi-panel :title="'Долгосрочные прогнозы'">
        <template v-slot:content>
          <v-expansion-panels>
            <wapi-api-panel
              :title="'ForecastLongLastTime'"
              :httpType="'GET'"
              :path="'/api/{api-version}/forecast/long/time'"
            >
              <template v-slot:description>
                <forecast-long-last-time />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'ForecastLong'"
              :httpType="'GET'"
              :path="'/api/{api-version}/forecast/long/point'"
            >
              <template v-slot:description>
                <forecast-long />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'ForecastLongPreset'"
              :httpType="'GET'"
              :path="'/api/{api-version}/forecast/long/preset/{presetId}'"
            >
              <template v-slot:description>
                <forecast-preset />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'ForecastLongPresets'"
              :httpType="'POST'"
              :path="'/api/{api-version}/forecast/long/presets'"
            >
              <template v-slot:description>
                <forecast-presets />
              </template>
            </wapi-api-panel>
          </v-expansion-panels>
        </template>
      </wapi-panel>

      <!-- Заказы территорий -->
      <wapi-panel :title="'Заказы территорий'">
        <template v-slot:content>
          <v-expansion-panels>
            <wapi-api-panel
              :title="'CreatePreset'"
              :httpType="'POST'"
              :path="'/api/{api-version}/presets/create'"
            >
              <template v-slot:description>
                <OrderPreset />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'GetPreset'"
              :httpType="'POST'"
              :path="'/api/{api-version}/presets/{presetid}'"
            >
              <template v-slot:description>
                <preset />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'DeletePreset'"
              :httpType="'DELETE'"
              :path="'/api/{api-version}/presets/{presetid}'"
            >
              <template v-slot:description>
                <delete-preset />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'Presets'"
              :httpType="'GET'"
              :path="'/api/{api-version}/presets'"
            >
              <template v-slot:description>
                <presets />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'DeletePresets'"
              :httpType="'DELETE'"
              :path="'/api/{api-version}/presets'"
            >
              <template v-slot:description>
                <delete-presets />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'PresetNames'"
              :httpType="'GET'"
              :path="'/api/{api-version}/presets/names?take=10&skip=0'"
            >
              <template v-slot:description>
                <cpreset-names />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'CountPresets'"
              :httpType="'GET'"
              :path="'/api/{api-version}/presets/count'"
            >
              <template v-slot:description>
                <count-presets />
              </template>
            </wapi-api-panel>
          </v-expansion-panels>
        </template>
      </wapi-panel>

      <!-- Реанализ -->
      <wapi-panel :title="'Реанализ'">
        <template v-slot:content>
          <v-expansion-panels>
            <wapi-api-panel
              :title="'Reanalysis'"
              :httpType="'GET'"
              :path="'/api/{api-version}/reanalysis/point?lat={latitude}&lon={longitude}&from={df}&to={dt}'"
            >
              <template v-slot:description>
                <reanalys />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'ReanalysisPreset'"
              :httpType="'GET'"
              :path="'/api/{api-version}/reanalysis/preset/{presetId}?from={df}&to={dt}'"
            >
              <template v-slot:description>
                <reanalys-preset />
              </template>
            </wapi-api-panel>
          </v-expansion-panels>
        </template>
      </wapi-panel>

      <!-- Биллинг -->
      <wapi-panel :title="'Биллинг'">
        <template v-slot:content>
          <v-expansion-panels>
            <wapi-api-panel
              :title="'BillingArea'"
              :httpType="'GET'"
              :path="'/api/{api-version}/billing/area'"
            >
              <template v-slot:description>
                <billing-area />
              </template>
            </wapi-api-panel>

            <wapi-api-panel
              :title="'BillingRequests'"
              :httpType="'GET'"
              :path="'/api/{api-version}/billing/requests'"
            >
              <template v-slot:description>
                <billing-requests />
              </template>
            </wapi-api-panel>
            <wapi-api-panel
              :title="'BillingRadarInfo'"
              :httpType="'GET'"
              :path="'/api/{api-version}/billing/radar/info'">
              <template v-slot:description>
                <billing-radar-info />
              </template>
            </wapi-api-panel>
          </v-expansion-panels>
        </template>
      </wapi-panel>
    </div>
  </div>
</template>

<script>
import Auth from "./api/Auth.vue";

import ForecastByPoint from "./api/forecast/ForecastByPoint.vue";
import Forecast from "./api/forecast/Forecast.vue";
import ForecastLastTime from "./api/forecast/ForecastLastTime";
import ForecastPresets from "./api/forecast/ForecastPresets.vue";
import ForecastPreset from "./api/forecast/ForecastPreset.vue";

import ForecastLong from "./api/forecastlong/ForecastLong";
import ForecastLongLastTime from "./api/forecastlong/ForecastLongLastTime";

import Presets from "./api/preset/Presets.vue";
import CountPresets from "./api/preset/CountPresets.vue";
import Preset from "./api/preset/Preset.vue";
import OrderPreset from "./api/preset/OrderPreset.vue";
import DeletePreset from "./api/preset/DeletePreset.vue";
import DeletePresets from "./api/preset/DeletePresets.vue";

import Reanalys from "./api/reanalysis/Reanalys.vue";
import ReanalysPreset from "./api/reanalysis/ReanalysPreset.vue";

import RadarValidTimesGeoJson from "./api/radar/RadarValidTimesGeoJson.vue";
import RadarLastTime from "./api/radar/RadarLastTime.vue";
import RadarValidTimes from "./api/radar/RadarValidTimes.vue";
import RadarTerritories from "./api/radar/RadarTerritories.vue";

import WapiPanel from "../components/WapiPanel.vue";
import WapiApiPanel from "../components/WapiApiPanel.vue";

import BillingArea from "./api/billing/BillingArea";
import BillingRadarInfo from "./api/billing/BillingRadarInfo";
import BillingRequests from "./api/billing/BillingRequests";

export default {
  components: {
    Auth,

    ForecastByPoint,
    Forecast,
    ForecastLastTime,
    ForecastPresets,
    ForecastPreset,

    ForecastLongLastTime,
    ForecastLong,

    Presets,
    CountPresets,
    Preset,
    OrderPreset,

    DeletePreset,
    DeletePresets,
    Reanalys,
    ReanalysPreset,

    RadarValidTimesGeoJson,
    RadarLastTime,
    RadarValidTimes,
    RadarTerritories,

    WapiPanel,
    WapiApiPanel,
    BillingArea,
    BillingRadarInfo,
    BillingRequests,
  },
  data() {
    return {
      panel: [],
      items: 5
    };
  },
  methods: {
    linkToHome() {
      this.$router.push({ name: "HOME" });
    }
  }
};
</script>